<div class="multiselect">
  <div class="multiselect-row" *ngFor="let option of options">
    <div class="multiselect-row-content">
      <input
        [id]="option.get('index')"
        class="checkbox"
        type="checkbox"
        [name]="option.get('name')"
        [value]="option.get('value')"
        [checked]="selected.get(option.get('index'))"
        (change)="handleFieldChange($event, option.get('index'))"
      />

      <label
        [for]="option.get('index')"
        [translationEditableDirective]="option.get('label')"
      >
        {{ option.get('label') | translate }}
      </label>

      <div class="is-flex">
        <span translationEditableDirective="FLOORS" style="font-size: 14px">{{
          'FLOORS' | translate
        }}</span
        ><span style="font-size: 14px" class="mr-1">:</span>
        <number-input
          *ngIf="!value"
          inputClass="input is-xsmall"
          name="percentage"
          step="0.01"
          style="width: 60px"
          [disabled]="!selected.get(option.get('index'))"
          [value]="selected.getIn([option.get('index'), 'percentage']) || ''"
          (input)="
            handleFieldChange($event, option.get('index'), option.get('label'))
          "
        />
        <number-input
          *ngIf="value"
          style="width: 60px"
          inputClass="input is-xsmall"
          name="value"
          step="0.01"
          [disabled]="!selected.get(option.get('index'))"
          [value]="selected.getIn([option.get('index'), 'value']) || ''"
          (input)="
            handleFieldChange($event, option.get('index'), option.get('label'))
          "
        />
      </div>
    </div>
    <div
      [ngClass]="{
        'form-property-group': row.get('isPropertyType')
      }"
    >
      <h6
        class="form-property-group-title"
        *ngIf="
          showChildren(row, option) &&
          row.get('isPropertyType') &&
          option.get('children').size
        "
        [translationEditableDirective]="option.get('label')"
      >
        {{ option.get('label') | translate }}
      </h6>
      <ng-container
        *ngIf="showChildren(row, option) && option.get('children').size"
      >
        <div *ngFor="let element of option.get('children')">
          <form-preview-element
            [isReadonly]="isReadonly"
            *ngIf="showChildren(row, option)"
            [row]="element"
            [values]="values"
            [activeForm]="activeForm"
            (onSelect)="onGroupSelect.emit($event)"
            (onSelectInput)="onGroupSelectInput.emit($event)"
            (onInput)="onGroupInput.emit($event)"
            [isVertical]="true"
          >
          </form-preview-element>
        </div>
      </ng-container>
    </div>
  </div>
</div>
